const localeTag = (code) => ({ fr: 'fr-FR', en: 'en-GB', he: 'he-IL', es: 'es-ES' })[code] ?? 'fr-FR';

export const formatDate = (value, locale) =>
  value ? new Intl.DateTimeFormat(localeTag(locale), { dateStyle: 'medium' }).format(new Date(value)) : '-';

export const formatDateTime = (value, locale) =>
  value
    ? new Intl.DateTimeFormat(localeTag(locale), { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value))
    : '-';

export const formatTime = (value, locale) =>
  value ? new Intl.DateTimeFormat(localeTag(locale), { timeStyle: 'short' }).format(new Date(value)) : '-';

export const formatDayLong = (value, locale) =>
  value
    ? new Intl.DateTimeFormat(localeTag(locale), { weekday: 'long', day: 'numeric', month: 'long' }).format(
        new Date(value),
      )
    : '-';

export const formatCurrency = (value, locale, currency = 'EUR') =>
  new Intl.NumberFormat(localeTag(locale), {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

export const formatNumber = (value, locale) => new Intl.NumberFormat(localeTag(locale)).format(Number(value) || 0);

/** "2026-09-14" for an <input type="date"> default. */
export const isoDay = (date = new Date()) => new Date(date).toISOString().slice(0, 10);

export const addDaysIso = (days, from = new Date()) => {
  const date = new Date(from);
  date.setDate(date.getDate() + days);
  return isoDay(date);
};

export const fullName = (person) => (person ? `${person.firstName} ${person.lastName}` : '-');
